$(document).ready(function () {
  var searchUrl = $('.js-search-villas-by-search-text').data('url');

  $('.js-search-villas-by-search-button').on('click', function () {
    var searchText = $(this)
      .closest('.js-search-wrapper')
      .find('.js-search-villas-by-search-text')
      .val();
    window.location.href = searchUrl + '?q=' + searchText;
  });

  $('.js-search-villas-by-search-text').on('keypress', function (e) {
    var searchText = $(this).val();
    if (e.which === 13) {
      window.location.href = searchUrl + '?q=' + searchText;
    }
  });
});
